import { API_BASE_URL } from "../config";

// 面试官配置项（后台配置格式）
export interface InterviewerConfig {
  id: string;
  name: string;
  avatar: string;
  gender: number;
  personality: string | null;
  voice: string;
  scenario: string | null;
  status: number;
}

// 公告数据接口
export interface AnnouncementData {
  publicDate: string;
  list: string[];
}

// 后台配置响应
export interface ConfigResponse {
  interviewers: InterviewerConfig[];
  displayVideoUrl: string;
  announcement: AnnouncementData | null;
}

// 获取后台配置信息
export async function fetchConfig(): Promise<ConfigResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/config`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("获取配置信息失败");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error("获取配置信息失败，请稍后重试");
  }
}
